/************ CONSTANTS ***********/
export const CURRENCY = '$';

export const NEW_ORDER = 0;
export const INPROGRESS_ORDER = 1;
export const COMPLETED_ORDER = 2;
export const api_base_url = "https://us-central1-user-f06f7.cloudfunctions.net/";
export const stripe_public_key = "pk_live_51Po6KOBV9Ahc2bL6SUMPLH1dP8vK7miUwXRmM04dpLeGGrxCgu6hYR65rHYinX68La7WomZY6gQK6swoHjvOUis000XnZDMUH4" ;  

export const APP_ID = "13_"

export const Bookings_Coll = APP_ID + "Bookings" 
export const Categories_Coll = APP_ID + "Categories" 
export const Contents_Coll = APP_ID + "Contents" 
export const Coupons_Coll = APP_ID + "Coupons" 
export const Customers_Coll = APP_ID + "Customers"  
export const Orders_Coll = APP_ID + "Orders" 
export const Products_Coll = APP_ID + "Products" 
export const PushMessages_Coll = APP_ID + "PushMessages" 
export const ServiceCats_Coll = APP_ID + "ServiceCats" 
export const Services_Coll = APP_ID + "Services" 
export const meta_Coll = APP_ID + "meta"  
export const productStats_Coll = APP_ID + "productStats" 
export const userOrderStats_Coll = APP_ID + "userOrderStats"  